export default (dataComp, sampleList, spam) => {
  const data = Object.keys(dataComp[0]).reduce((result, key, index) => {
    return { ...result, [key]: sampleList[index] || dataComp[0][key].next };
  }, {});
  return [data];
};
